export const getFileTypeFromName = (name) => {
  if (!name) return "";
  let splits = name.split(".");
  if (splits.length > 1) return splits[splits.length - 1] || ".txt";
  return "";
};
